/* HALSTEAD — storefront enhancements
   1) tiered cart progress bar   2) image colour swatches
   3) fit finder (size assistant) 4) small UX fixes             */
(function () {
  'use strict';

  var CFG = (window.HALSTEAD = window.HALSTEAD || {});
  var TIERS = CFG.tiers || [
    { qty: 2, pct: 10 },
    { qty: 3, pct: 15 },
    { qty: 4, pct: 20 }
  ];

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  /* =================================================== 1. CART PROGRESS */

  function progressMarkup() {
    var steps = TIERS.map(function (t) {
      return '<li data-q="' + t.qty + '">' + t.qty + ' items &middot; ' + t.pct + '%</li>';
    }).join('');
    return (
      '<p class="hal-prog__msg" data-hal-prog-msg></p>' +
      '<div class="hal-prog__track"><span class="hal-prog__fill" data-hal-prog-fill></span></div>' +
      '<ul class="hal-prog__steps">' + steps + '</ul>'
    );
  }

  function ensureProgress() {
    var drawer = $('#CartDrawer');
    if (!drawer) return null;
    var node = $('[data-hal-prog]', drawer);
    if (node) return node;
    var host = $('.drawer__inner', drawer) || drawer;
    node = el('div', 'hal-prog');
    node.setAttribute('data-hal-prog', '');
    node.innerHTML = progressMarkup();
    host.insertBefore(node, host.firstChild);
    return node;
  }

  function renderProgress(count) {
    var node = ensureProgress();
    if (!node) return;
    var max = TIERS[TIERS.length - 1].qty;
    var current = null, next = null;
    TIERS.forEach(function (t) {
      if (count >= t.qty) current = t;
      else if (!next) next = t;
    });

    var msg = $('[data-hal-prog-msg]', node);
    var fill = $('[data-hal-prog-fill]', node);
    if (!msg || !fill) return;

    if (count === 0) {
      msg.innerHTML = 'Add <b>2 pieces</b> and 10% comes off automatically.';
    } else if (next) {
      var need = next.qty - count;
      msg.innerHTML =
        (current ? '<b>' + current.pct + '% off</b> applied. ' : '') +
        'Add <b>' + need + ' more</b> to reach <b>' + next.pct + '% off</b>.';
    } else {
      msg.innerHTML = 'You have unlocked the full <b>' + current.pct + '% off</b>.';
    }
    var pct = Math.max(0, Math.min(100, (count / max) * 100));
    fill.style.width = pct + '%';

    $$('.hal-prog__steps li', node).forEach(function (li) {
      li.classList.toggle('is-on', count >= parseInt(li.getAttribute('data-q'), 10));
    });
  }

  function readCartCount() {
    var items = $('#CartDrawer .cart__items');
    if (items && items.hasAttribute('data-count')) {
      return parseInt(items.getAttribute('data-count'), 10) || 0;
    }
    var n = 0;
    $$('#CartDrawer .js-qty__num').forEach(function (i) {
      n += parseInt(i.value, 10) || 0;
    });
    return n;
  }

  function refreshFromServer() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderProgress(c.item_count || 0); })
      .catch(function () { renderProgress(readCartCount()); });
  }

  function watchCart() {
    if (!$('#CartDrawer')) return;
    refreshFromServer();

    var host = $('#CartDrawer [data-products]');
    if (host && 'MutationObserver' in window) {
      new MutationObserver(function () { renderProgress(readCartCount()); })
        .observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-count'] });
    }

    var isCartUrl = function (u) { return typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u); };
    if (window.fetch) {
      var _f = window.fetch;
      window.fetch = function () {
        var url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
        var p = _f.apply(this, arguments);
        if (isCartUrl(url) && p && p.then) p.then(function () { setTimeout(refreshFromServer, 260); });
        return p;
      };
    }
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      if (isCartUrl(u)) this.addEventListener('load', function () { setTimeout(refreshFromServer, 260); });
      return _open.apply(this, arguments);
    };
  }

  /* ================================================ 2. COLOUR SWATCHES */

  var COLOR_KEYS = ['color', 'colour', 'farbe', 'couleur', 'colore'];

  function variantData() {
    var ta = $('[data-variant-json]');
    if (!ta) return null;
    try { return JSON.parse(ta.value || ta.textContent); } catch (e) { return null; }
  }

  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('?') > -1) return src.split('?')[0] + '?width=' + w;
    return src + '?width=' + w;
  }

  function buildSwatches() {
    var variants = variantData();
    if (!variants || !variants.length) return;

    $$('.variant-input-wrap').forEach(function (wrap) {
      var handle = (wrap.getAttribute('data-handle') || '').toLowerCase();
      var name = (wrap.getAttribute('name') || '').toLowerCase();
      var isColor = COLOR_KEYS.some(function (k) { return handle.indexOf(k) > -1 || name.indexOf(k) > -1; });
      if (!isColor || wrap.classList.contains('hal-swatches')) return;

      var idx = parseInt((wrap.getAttribute('data-index') || 'option1').replace('option', ''), 10);
      var key = 'option' + idx;

      var byValue = {};
      variants.forEach(function (v) {
        var val = v[key];
        if (!val) return;
        if (!byValue[val]) byValue[val] = { img: null, available: false };
        if (v.available) byValue[val].available = true;
        if (!byValue[val].img && v.featured_image && v.featured_image.src) byValue[val].img = v.featured_image.src;
      });

      var withImages = Object.keys(byValue).filter(function (k) { return byValue[k].img; }).length;
      if (withImages < 1) return;

      wrap.classList.add('hal-swatches');
      $$('.variant-input', wrap).forEach(function (item) {
        var value = item.getAttribute('data-value');
        var input = $('input', item);
        var label = $('label', item);
        if (!input || !label) return;
        var info = byValue[value] || {};
        var img = info.img || (variants[0] && variants[0].featured_image ? variants[0].featured_image.src : '');
        label.className = 'hal-swatch' + (info.available === false ? ' hal-swatch--disabled' : '');
        label.innerHTML =
          '<span class="hal-swatch__tile">' +
            (img ? '<img src="' + sized(img, 200) + '" alt="' + value + '" loading="lazy">' : '') +
          '</span><span class="hal-swatch__name">' + value + '</span>';
      });
    });
  }

  /* ==================================================== 3. FIT FINDER */

  var FF = {
    APPAREL_W: ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'],
    APPAREL_M: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'],

    normalise: function (s) {
      var t = String(s).trim().toUpperCase().replace(/\s+/g, '');
      if (t === 'XXL') return '2XL';
      if (t === 'XXXL') return '3XL';
      return t;
    },

    womenBase: function (lbs) {
      if (lbs < 108) return 0;
      if (lbs < 120) return 1;
      if (lbs < 135) return 2;
      if (lbs < 155) return 3;
      if (lbs < 180) return 4;
      if (lbs < 205) return 5;
      if (lbs < 235) return 6;
      return 7;
    },
    menBase: function (lbs) {
      if (lbs < 135) return 0;
      if (lbs < 158) return 1;
      if (lbs < 182) return 2;
      if (lbs < 208) return 3;
      if (lbs < 238) return 4;
      if (lbs < 268) return 5;
      return 6;
    },

    category: function (title, type) {
      var t = (title + ' ' + (type || '')).toLowerCase();
      if (/(boot|sandal|sneaker|trainer|loafer|heel|pump|flat|mule|slipper|shoe|derby|oxford|chelsea)/.test(t)) return 'shoes';
      if (/(coat|jacket|parka|blazer|trench|puffer|overcoat|windbreaker|cape)/.test(t)) return 'outerwear';
      if (/(sweater|knit|cardigan|pullover|hoodie|turtleneck|jumper|fleece|sweatshirt)/.test(t)) return 'knitwear';
      if (/(pant|trouser|jean|chino|short|legging|skirt)/.test(t)) return 'bottoms';
      if (/dress|gown|jumpsuit|romper/.test(t)) return 'dress';
      if (/(suit|set|two-piece|three-piece|tuxedo)/.test(t)) return 'suit';
      return 'top';
    },

    copy: {
      dress: 'Dresses are cut true to size with a little ease through the waist.',
      outerwear: 'Outerwear is cut with room for a knit underneath.',
      knitwear: 'Knitwear is relaxed by design — it softens and gives with wear.',
      bottoms: 'Trousers run true to size; between sizes we suggest the larger one.',
      top: 'Tops and shirting run true to size.',
      suit: 'Tailoring is cut close through the shoulder — go by your jacket size.',
      shoes: 'Our shoes run true to size.'
    }
  };

  function fitContext() {
    var root = $('[data-hal-fit]');
    if (!root) return null;
    var d = {};
    try { d = JSON.parse(root.getAttribute('data-hal-fit')); } catch (e) { d = {}; }
    d.category = FF.category(d.title || '', d.type || '');
    return d;
  }

  function sizeFieldset() {
    var sets = $$('.variant-input-wrap');
    for (var i = 0; i < sets.length; i++) {
      var h = (sets[i].getAttribute('data-handle') || '').toLowerCase();
      var n = (sets[i].getAttribute('name') || '').toLowerCase();
      if (/size|größe|grosse|groesse|taille|talla/.test(h + ' ' + n)) return sets[i];
    }
    return null;
  }

  function availableSizes() {
    var fs = sizeFieldset();
    if (!fs) return [];
    return $$('.variant-input', fs).map(function (i) {
      var input = $('input', i);
      return {
        value: i.getAttribute('data-value'),
        node: input,
        disabled: input ? input.classList.contains('disabled') : false
      };
    });
  }

  function pickClosest(target, options, scale) {
    var idxOf = function (v) { return scale.indexOf(FF.normalise(v)); };
    var usable = options.filter(function (o) { return idxOf(o.value) > -1; });
    if (!usable.length) return null;
    var best = null, bestD = 99;
    usable.forEach(function (o) {
      var d = Math.abs(idxOf(o.value) - target);
      if (d < bestD || (d === bestD && best && best.disabled && !o.disabled)) { best = o; bestD = d; }
    });
    return best;
  }

  function recommend(state, ctx) {
    var cat = ctx.category;
    var opts = availableSizes();

    if (cat === 'shoes') {
      var want = parseFloat(state.shoe);
      var exact = opts.filter(function (o) { return parseFloat(o.value) === want; })[0];
      var note = 'Our shoes run true to size, so your usual size is the right call.';
      if (state.width === 'wide') {
        note = 'You told us your foot is on the wide side, so we have gone half a size up.';
        var up = opts.filter(function (o) {
          return parseFloat(o.value) === want + 0.5 || parseFloat(o.value) === want + 1;
        })[0];
        if (up) exact = up;
      } else if (state.width === 'narrow') {
        note = 'For a narrow foot your usual size is right — a thicker sock will fill it out.';
      }
      if (!exact) {
        exact = opts.filter(function (o) { return !o.disabled; })[0];
        note = 'Your exact size is not in stock right now — this is the closest we have.';
      }
      return {
        size: exact ? exact.value : null,
        node: exact ? exact.node : null,
        why: note,
        soldOut: exact ? exact.disabled : true
      };
    }

    var scale = ctx.gender === 'men' ? FF.APPAREL_M : FF.APPAREL_W;
    var base = ctx.gender === 'men' ? FF.menBase(state.lbs) : FF.womenBase(state.lbs);

    if (state.inches >= 71 && ctx.gender === 'women') base += 0.4;
    if (state.inches >= 75 && ctx.gender === 'men') base += 0.4;
    if (state.inches <= 62 && ctx.gender === 'women') base -= 0.4;
    if (state.inches <= 66 && ctx.gender === 'men') base -= 0.4;

    if (state.build === 'slim') base -= 0.5;
    if (state.build === 'curvy') base += 0.5;
    if (state.build === 'full') base += 0.9;

    if (state.fit === 'close') base -= 0.6;
    if (state.fit === 'relaxed') base += 0.8;

    if (cat === 'outerwear') base += 0.35;
    if (cat === 'knitwear') base -= 0.25;
    if (cat === 'bottoms') base += 0.2;
    if (cat === 'suit') base += 0.1;

    var target = Math.round(base);
    if (target < 0) target = 0;
    if (target > scale.length - 1) target = scale.length - 1;

    var choice = pickClosest(target, opts, scale);
    return {
      size: choice ? choice.value : null,
      node: choice ? choice.node : null,
      why: FF.copy[cat] || FF.copy.top,
      soldOut: choice ? choice.disabled : true
    };
  }

  function openModal() {
    var m = $('#HalFit');
    if (!m) return;
    m.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var active = $('.hal-ff__step.is-active', m);
    var f = active ? $('input,select,button', active) : null;
    if (f) f.focus();
  }
  function closeModal() {
    var m = $('#HalFit');
    if (!m) return;
    m.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function initFit() {
    var ctx = fitContext();
    var modal = $('#HalFit');
    if (!ctx || !modal) return;

    var fs = sizeFieldset();
    if (!fs) return;

    var wrapper = fs.closest ? fs.closest('.variant-wrapper') : fs.parentNode;
    var label = wrapper ? $('.variant__label', wrapper) : null;
    if (label && wrapper && !$('.hal-fitbtn', wrapper)) {
      var row = el('div', 'hal-size-head');
      label.parentNode.insertBefore(row, label);
      row.appendChild(label);
      var btn = el('button', 'hal-fitbtn',
        '<svg viewBox="0 0 24 24"><path d="M3 8h18v8H3z"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/></svg>Find my size');
      btn.type = 'button';
      row.appendChild(btn);
      btn.addEventListener('click', openModal);
      var hint = el('span', 'hal-fitbtn__hint',
        'Three questions about your height, build and how you like things to sit — about ten seconds.');
      wrapper.insertBefore(hint, fs);
    }

    var isShoes = ctx.category === 'shoes';
    modal.setAttribute('data-mode', isShoes ? 'shoes' : 'apparel');
    modal.setAttribute('data-gender', ctx.gender || 'women');

    $$('[data-hal-shoe-only]', modal).forEach(function (n) { n.style.display = isShoes ? '' : 'none'; });
    $$('[data-hal-apparel-only]', modal).forEach(function (n) { n.style.display = isShoes ? 'none' : ''; });

    var shoeSel = $('#halShoeSize', modal);
    if (shoeSel && isShoes) {
      shoeSel.innerHTML = '';
      availableSizes().forEach(function (o) {
        var op = document.createElement('option');
        op.value = o.value;
        op.textContent = 'US ' + o.value + (o.disabled ? ' — sold out' : '');
        shoeSel.appendChild(op);
      });
    }

    var state = { build: 'average', fit: 'true', width: 'average' };
    var stepIds = isShoes ? ['s-shoe', 's-width', 's-result'] : ['s-body', 's-build', 's-fit', 's-result'];
    var at = 0;

    function show(i) {
      at = Math.max(0, Math.min(stepIds.length - 1, i));
      $$('.hal-ff__step', modal).forEach(function (s) { s.classList.remove('is-active'); });
      var node = $('#' + stepIds[at], modal);
      if (node) node.classList.add('is-active');
      $$('[data-hal-dots]', modal).forEach(function (dots) {
        dots.innerHTML = stepIds.map(function (_, k) {
          return '<i class="' + (k <= at ? 'on' : '') + '"></i>';
        }).join('');
      });
      $$('[data-hal-back]', modal).forEach(function (b) {
        b.style.visibility = at === 0 ? 'hidden' : 'visible';
      });
    }

    function validateBody() {
      var ft = parseInt($('#halFt', modal).value, 10);
      var inch = parseInt($('#halIn', modal).value, 10) || 0;
      var lbs = parseInt($('#halLbs', modal).value, 10);
      var err = $('[data-hal-err]', modal);
      if (!ft || ft < 4 || ft > 7 || !lbs || lbs < 70 || lbs > 450) {
        if (err) err.classList.add('is-on');
        return false;
      }
      if (err) err.classList.remove('is-on');
      state.inches = ft * 12 + inch;
      state.lbs = lbs;
      return true;
    }

    function finish() {
      if (isShoes && $('#halShoeSize', modal)) state.shoe = $('#halShoeSize', modal).value;
      var r = recommend(state, ctx);
      var out = $('[data-hal-result]', modal);
      if (!out) return;

      if (!r.size) {
        out.innerHTML = '<p class="hal-ff__why">We could not match a size here. Email <a href="mailto:info@halstead.com">info@halstead.com</a> with your measurements and we will pick one for you.</p>';
        show(stepIds.length - 1);
        return;
      }

      out.innerHTML =
        '<p class="hal-eyebrow">Your recommended size</p>' +
        '<div class="hal-ff__badge">' + r.size + '</div>' +
        '<p class="hal-ff__conf"><svg viewBox="0 0 24 24"><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>' +
          (r.soldOut ? 'Currently sold out' : 'Best match for your answers') + '</p>' +
        '<p class="hal-ff__why">' + r.why + '</p>' +
        (r.soldOut ? '' : '<button type="button" class="btn" data-hal-add>Add size ' + r.size + ' to bag</button>') +
        '<p class="hal-ff__alt"><button type="button" data-hal-restart>Start again</button></p>' +
        '<div class="hal-ff__help">Between sizes or still unsure? Write to <a href="mailto:info@halstead.com">info@halstead.com</a> with your usual size and height and a member of our team will tell you what to order — usually within a few hours. You also have 90 days to send anything back.</div>';

      var add = $('[data-hal-add]', out);
      if (add) {
        add.addEventListener('click', function () {
          if (r.node) {
            r.node.checked = true;
            r.node.dispatchEvent(new Event('change', { bubbles: true }));
            r.node.dispatchEvent(new Event('click', { bubbles: true }));
          }
          closeModal();
          setTimeout(function () {
            var atc = $('[data-add-to-cart]') || $('.add-to-cart');
            if (atc) atc.click();
          }, 220);
        });
      }
      var again = $('[data-hal-restart]', out);
      if (again) again.addEventListener('click', function () { show(0); });
      show(stepIds.length - 1);
    }

    modal.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-hal-close]') || t.classList.contains('hal-modal__scrim')) { closeModal(); return; }
      if (t.closest('[data-hal-next]')) {
        if (stepIds[at] === 's-body' && !validateBody()) return;
        if (at === stepIds.length - 2) { finish(); } else { show(at + 1); }
        return;
      }
      if (t.closest('[data-hal-back]')) { show(at - 1); return; }
      var opt = t.closest('.hal-ff__opt');
      if (opt) {
        var group = opt.parentNode;
        $$('.hal-ff__opt', group).forEach(function (o) { o.classList.remove('is-sel'); });
        opt.classList.add('is-sel');
        var inp = $('input', opt);
        if (inp) {
          inp.checked = true;
          state[inp.name] = inp.value;
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    show(0);
  }

  /* ==================================================== 4. SMALL FIXES */

  function tidy() {
    $$('.product-block, .grid__item').forEach(function (n) {
      if (!n.textContent.trim() && !n.querySelector('img,svg,video,iframe,input,button,select')) {
        n.classList.add('hal-empty');
      }
    });
  }

  function boot() {
    try { watchCart(); } catch (e) {}
    try { buildSwatches(); } catch (e) {}
    try { initFit(); } catch (e) {}
    try { tidy(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(boot, 60);
  });
})();
